import { useState } from "react";
import { toast } from "sonner";
import { Reveal } from "@/components/lunar/Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

const inputCls =
    "w-full rounded-xl border border-[#C2C0B8] bg-transparent px-4 py-3 text-sm text-[#1D201A] placeholder:text-[#5C5F58] focus:border-[#4A5D23] focus:outline-none";
const labelCls = "mb-1.5 block text-xs font-medium uppercase tracking-[0.14em] text-[#5C5F58]";

export const EventsEnquiryForm = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        organisation: "",
        event: "",
        date: "",
        message: "",
    });
    const [status, setStatus] = useState("idle");
    const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setStatus("sending");
        try {
            const res = await fetch(`${API}/api/venue-request`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: form.name,
                    email: form.email,
                    organisation: form.organisation,
                    venue_name: form.event,
                    event_date: form.date,
                    comments: form.message,
                    package: "Lunar event activation enquiry",
                    venue_type: "Event activation",
                }),
            });
            if (!res.ok) throw new Error("send failed");
            setStatus("sent");
        } catch {
            setStatus("idle");
            toast.error("Something went wrong sending your enquiry — please try again.");
        }
    };

    if (status === "sent") {
        return (
            <Reveal>
                <div data-testid="events-enquiry-confirmation" className="mt-12 rounded-3xl border border-[#899B6A] bg-[#D5D8CB]/40 p-10 text-center sm:p-14">
                    <h2 className="font-display text-3xl font-medium text-[#2C3618] sm:text-4xl">
                        Thanks — we’ve received your enquiry.
                    </h2>
                    <p className="mt-4 text-base text-[#3E413B]">
                        We’ll be in touch to talk about your event and the right Lunar setup.
                    </p>
                </div>
            </Reveal>
        );
    }

    return (
        <Reveal delay={0.1}>
            <form id="events-enquiry" onSubmit={submit} className="mt-12 grid scroll-mt-8 gap-5 text-left" data-testid="events-enquiry-form">
                    <div className="grid gap-5 sm:grid-cols-2">
                        <div>
                            <label className={labelCls}>Name <span className="text-[#4A5D23]">*</span></label>
                            <input required data-testid="events-form-name" className={inputCls} value={form.name} onChange={set("name")} />
                        </div>
                        <div>
                            <label className={labelCls}>Email <span className="text-[#4A5D23]">*</span></label>
                            <input required type="email" data-testid="events-form-email" className={inputCls} value={form.email} onChange={set("email")} />
                        </div>
                    </div>
                    <div className="grid gap-5 sm:grid-cols-2">
                        <div>
                            <label className={labelCls}>Organisation</label>
                            <input data-testid="events-form-organisation" className={inputCls} value={form.organisation} onChange={set("organisation")} />
                        </div>
                        <div>
                            <label className={labelCls}>Event name <span className="text-[#4A5D23]">*</span></label>
                            <input required data-testid="events-form-event" className={inputCls} value={form.event} onChange={set("event")} />
                        </div>
                    </div>
                    <div>
                        <label className={labelCls}>Event date (if known)</label>
                        <input type="date" data-testid="events-form-date" className={inputCls} value={form.date} onChange={set("date")} />
                    </div>
                    <div>
                        <label className={labelCls}>Tell us about your event</label>
                        <textarea
                            rows={4}
                            data-testid="events-form-message"
                            className={inputCls}
                            placeholder="Type of event, rough attendance, what you’d like Lunar to do…"
                            value={form.message}
                            onChange={set("message")}
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            data-testid="events-form-submit"
                            disabled={status === "sending"}
                            className="w-full rounded-full bg-[#2C3618] py-4 text-sm font-bold text-[#F9F8F4] transition-[background-color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#4A5D23] disabled:opacity-60 sm:w-auto sm:px-12"
                        >
                            {status === "sending" ? "Sending…" : "Bring Lunar to your event"}
                        </button>
                    </div>
            </form>
        </Reveal>
    );
};
